export const isEscortAvailableToday = (escort) => {
    let availability = _.get(escort, 'future_availability', [])
    if (!availability.length) {
        availability = _.get(escort, 'availability', [])
    }

    availability = _.map(availability, a => a.date);
    const today = moment().format('YYYY-MM-DD');

    return availability.includes(today);
}